import React from 'react';

const FragmentLoader = () => (
  <svg className="fragment-loader is-centered">
    <rect className="fragment-square left" width="10" height="10" />
    <rect className="fragment-square middle" width="10" height="10" />
    <rect className="fragment-square right" width="10" height="10" />
  </svg>
);

export default FragmentLoader;



// WEBPACK FOOTER //
// ./src/components/fragmentLoader.js